/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Txn } from '@src/app/model/txn';
import { AbstractPageComponent } from '@src/app/shared/form/abstract-page.component';
import { FieldSet } from '@src/app/shared/form/field-set/field-set.component';
import { FormConfig } from "@src/app/shared/form/FormConfig";
import { BCodeService } from '@src/app/modules/budget/bcode.service';
import { ApTxnService } from '@src/app/modules/txn/ap-txn.service';
import { FormPageComponent } from '@src/app/shared/form/form-page/form-page.component';
import { PurchaseService } from '@src/app/modules/txn/purchase.service';
import { ApPageNavRoute } from '@src/app/routes/ap-page-nav';

@Component({
    selector: 'app-ap-page',
    templateUrl: './ap-page.component.html',
    styleUrls: ['./ap-page.component.scss'],
    imports: [FormPageComponent]
})
export class ApPageComponent extends AbstractPageComponent {
  dataSvc = inject(ApTxnService);
  bCodeSvc = inject(BCodeService);
  private purchaseSvc = inject(PurchaseService);
  protected activeRoute = inject(ActivatedRoute);


  readonly path = Txn.LEDGER.AP.code;

  config = new FormConfig({
    navRoute: ApPageNavRoute,
    title: Txn.LEDGER.AP.name,
    help: $localize`Accounts Payable Transactions`,
    fieldSet: new FieldSet({
      fields: this.dataSvc.getFields(),
      formLayout: [
        { cells: [{ width: '25%' }, { width: '25%' }, { width: '25%' }, { width: '25%' }] },
        { cells: [{ colspan: 4, pageTab: 'yes' }] }
      ],
    }),
    service: this.dataSvc,
    mode: 'list',
    objectFactory: () => of(null), // this.newFactory.bind(this),
    newOptions: this.purchaseSvc.getNewOptions(),
    pathEdit: (o: Txn) => Txn.getTxnLink(o)
  });

  newFactory(): Observable<Txn> {
    const txn = new Txn();
    txn.typeId = +this.activeRoute.snapshot.queryParamMap.get('typeId');
    console.warn(txn, this.activeRoute.snapshot);
    return of(txn);
  }

}
